(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cc-chair-pack-selector"] && !Shopify.designMode) return;
  try {
    (() => {
      const roots = document.querySelectorAll('[data-cc-chair-pack]');

      roots.forEach((root) => {
        if (root.dataset.initialized === 'true') return;
        root.dataset.initialized = 'true';

        const variants = JSON.parse(root.querySelector('[data-cc-pack-variants]').textContent);
        const availableVariants = variants.filter((variant) => variant.available);
        const radios = Array.from(root.querySelectorAll('input[name="cc-chair-pack-size"]'));
        const colorsWrap = root.querySelector('[data-cc-pack-colors]');
        const colorGrid = root.querySelector('[data-cc-pack-color-grid]');
        const summary = root.querySelector('[data-cc-pack-summary]');
        const total = root.querySelector('[data-cc-pack-total]');
        const each = root.querySelector('[data-cc-pack-each]');
        const addButton = root.querySelector('[data-cc-pack-add]');
        const status = root.querySelector('[data-cc-pack-status]');
        const infoContainer = root.closest('.product__info-container');
        const currency = window.Shopify?.currency?.active || 'USD';

        const formatMoney = (cents) => new Intl.NumberFormat(
          document.documentElement.lang || 'en-US',
          { style: 'currency', currency }
        ).format(Number(cents || 0) / 100);

        const mainForm = () => {
          if (!infoContainer) return null;
          return infoContainer.querySelector('form[action*="/cart/add"]');
        };

        const selectedMainVariantId = () => mainForm()?.querySelector('input[name="id"]')?.value;

        const discountFor = (count) => {          if (count === 3) return 10;
          if (count === 2) return 5;
          return 0;
        };

        const buildColorSelectors = (count) => {
          const currentValues = Array.from(colorGrid.querySelectorAll('select')).map((select) => select.value);
          const mainId = selectedMainVariantId();
          colorGrid.innerHTML = '';

          for (let index = 0; index < count; index += 1) {
            const label = document.createElement('label');
            label.className = 'cc-chair-pack__color';
            const colorLabel = root.dataset.colorLabel.replace('__COUNT__', index + 1);
            label.textContent = colorLabel;

            const select = document.createElement('select');
            select.setAttribute('aria-label', colorLabel);
            select.dataset.ccPackColor = '';

            availableVariants.forEach((variant) => {
              const option = document.createElement('option');
              option.value = variant.id;
              option.textContent = variant.title;
              option.dataset.price = variant.price;
              select.appendChild(option);
            });

            select.value = currentValues[index] || mainId || availableVariants[0]?.id;
            select.addEventListener('change', refresh);
            label.appendChild(select);
            colorGrid.appendChild(label);
          }
        };

        const selectedCount = () => Number(radios.find((radio) => radio.checked)?.value || 1);

        const refresh = () => {
          const count = selectedCount();
          const packMode = count > 1;

          if (packMode && colorGrid.querySelectorAll('select').length !== count) {
            buildColorSelectors(count);
          }

          colorsWrap.hidden = !packMode;
          summary.hidden = !packMode;
          addButton.hidden = !packMode;
          infoContainer?.classList.toggle('cc-chair-pack-mode', packMode);

          if (!packMode) {
            status.textContent = '';
            return;
          }

          const selectedVariants = Array.from(colorGrid.querySelectorAll('select')).map((select) => (
            availableVariants.find((variant) => String(variant.id) === String(select.value))
          )).filter(Boolean);

          const subtotal = selectedVariants.reduce((sum, variant) => sum + Number(variant.price), 0);
          const percent = discountFor(count);
          const estimated = Math.round(subtotal * (1 - percent / 100));
          const perChair = Math.round(estimated / count);
          const saved = subtotal - estimated;

          total.textContent = formatMoney(estimated);
          each.textContent = `${formatMoney(perChair)} ${root.dataset.eachLabel} · ${root.dataset.saveLabel} ${formatMoney(saved)}`;
          addButton.textContent = root.dataset.addLabel.replace('__COUNT__', count);
        };

        radios.forEach((radio) => radio.addEventListener('change', refresh));

        infoContainer?.addEventListener('change', (event) => {
          if (!event.target.closest('form[action*="/cart/add"]')) return;
          const firstSelect = colorGrid.querySelector('select');
          const mainId = selectedMainVariantId();
          if (firstSelect && mainId) firstSelect.value = mainId;
          refresh();
        });

        document.addEventListener('variant:change', () => {
          window.setTimeout(() => {
            const firstSelect = colorGrid.querySelector('select');
            const mainId = selectedMainVariantId();
            if (firstSelect && mainId) firstSelect.value = mainId;
            refresh();
          }, 0);
        });

        addButton.addEventListener('click', async () => {
          const selects = Array.from(colorGrid.querySelectorAll('select'));
          const quantities = new Map();

          selects.forEach((select) => {
            quantities.set(select.value, (quantities.get(select.value) || 0) + 1);
          });

          const items = Array.from(quantities, ([id, quantity]) => ({
            id: Number(id),
            quantity
          }));

          addButton.disabled = true;
          status.textContent = '';

          try {
            const drawer = document.querySelector('cart-drawer');
            const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                items,
                sections: 'cart-drawer,cart-icon-bubble',
                sections_url: window.location.pathname || '/'
              })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || root.dataset.errorLabel);
            if (!drawer?.renderContents || !result.sections) {
              throw new Error('Your chairs were added, but the cart drawer could not open. Please use the cart icon.');
            }

            status.textContent = root.dataset.addedLabel;
            addButton.disabled = false;
            drawer.setActiveElement?.(addButton);
            drawer.renderContents(result);
          } catch (error) {
            status.textContent = error.message || root.dataset.errorLabel;
            addButton.disabled = false;
          }
        });

        refresh();
      });
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cc-towel-pack-selector"] && !Shopify.designMode) return;
  try {
    (() => {
      const roots = document.querySelectorAll('[data-cc-towel-pack]');

      roots.forEach((root) => {
        if (root.dataset.initialized === 'true') return;
        root.dataset.initialized = 'true';

        const variants = JSON.parse(root.querySelector('[data-cc-pack-variants]').textContent);
        const availableVariants = variants.filter((variant) => variant.available);
        const radios = Array.from(root.querySelectorAll('input[name="cc-towel-pack-size"]'));
        const colorsWrap = root.querySelector('[data-cc-pack-colors]');
        const colorGrid = root.querySelector('[data-cc-pack-color-grid]');
        const summary = root.querySelector('[data-cc-pack-summary]');
        const total = root.querySelector('[data-cc-pack-total]');
        const each = root.querySelector('[data-cc-pack-each]');
        const addButton = root.querySelector('[data-cc-pack-add]');
        const status = root.querySelector('[data-cc-pack-status]');
        const infoContainer = root.closest('.product__info-container');
        const currency = window.Shopify?.currency?.active || 'USD';

        const formatMoney = (cents) => new Intl.NumberFormat(
          document.documentElement.lang || 'en-US',
          { style: 'currency', currency }
        ).format(Number(cents || 0) / 100);

        const mainForm = () => {
          if (!infoContainer) return null;
          return infoContainer.querySelector('form[action*="/cart/add"]');
        };

        const selectedMainVariantId = () => mainForm()?.querySelector('input[name="id"]')?.value;

        const discountFor = (count) => {
          if (count >= 4) return 20;
          if (count === 3) return 15;
          if (count === 2) return 10;
          return 0;
        };

        const buildColorSelectors = (count) => {
          const currentValues = Array.from(colorGrid.querySelectorAll('select')).map((select) => select.value);
          const mainId = selectedMainVariantId();
          colorGrid.innerHTML = '';

          for (let index = 0; index < count; index += 1) {
            const label = document.createElement('label');
            label.className = 'cc-towel-pack__color';
            const colorLabel = root.dataset.colorLabel.replace('__COUNT__', index + 1);
            label.textContent = colorLabel;

            const select = document.createElement('select');
            select.setAttribute('aria-label', colorLabel);
            select.dataset.ccPackColor = '';

            availableVariants.forEach((variant) => {
              const option = document.createElement('option');
              option.value = variant.id;
              option.textContent = variant.title;
              option.dataset.price = variant.price;
              select.appendChild(option);
            });

            select.value = currentValues[index] || mainId || availableVariants[0]?.id;
            select.addEventListener('change', refresh);
            label.appendChild(select);
            colorGrid.appendChild(label);
          }
        };

        const selectedCount = () => Number(radios.find((radio) => radio.checked)?.value || 1);

        const refresh = () => {
          const count = selectedCount();
          const packMode = count > 1;

          if (packMode && colorGrid.querySelectorAll('select').length !== count) {
            buildColorSelectors(count);
          }

          colorsWrap.hidden = !packMode;
          summary.hidden = !packMode;
          addButton.hidden = !packMode;
          infoContainer?.classList.toggle('cc-towel-pack-mode', packMode);

          if (!packMode) {
            status.textContent = '';
            return;
          }

          const selectedVariants = Array.from(colorGrid.querySelectorAll('select')).map((select) => (
            availableVariants.find((variant) => String(variant.id) === String(select.value))
          )).filter(Boolean);

          const subtotal = selectedVariants.reduce((sum, variant) => sum + Number(variant.price), 0);
          const percent = discountFor(count);
          const estimated = Math.round(subtotal * (1 - percent / 100));
          const perTowel = Math.round(estimated / count);
          const saved = subtotal - estimated;

          total.textContent = formatMoney(estimated);
          each.textContent = `${formatMoney(perTowel)} ${root.dataset.eachLabel} · ${root.dataset.saveLabel} ${formatMoney(saved)}`;
          addButton.textContent = root.dataset.addLabel.replace('__COUNT__', count);
        };

        radios.forEach((radio) => radio.addEventListener('change', refresh));

        infoContainer?.addEventListener('change', (event) => {
          if (!event.target.closest('form[action*="/cart/add"]')) return;
          const firstSelect = colorGrid.querySelector('select');
          const mainId = selectedMainVariantId();
          if (firstSelect && mainId) firstSelect.value = mainId;
          refresh();
        });

        document.addEventListener('variant:change', () => {
          window.setTimeout(() => {
            const firstSelect = colorGrid.querySelector('select');
            const mainId = selectedMainVariantId();
            if (firstSelect && mainId) firstSelect.value = mainId;
            refresh();
          }, 0);
        });

        addButton.addEventListener('click', async () => {
          const selects = Array.from(colorGrid.querySelectorAll('select'));
          const quantities = new Map();

          selects.forEach((select) => {
            quantities.set(select.value, (quantities.get(select.value) || 0) + 1);
          });

          const items = Array.from(quantities, ([id, quantity]) => ({
            id: Number(id),
            quantity
          }));

          addButton.disabled = true;
          status.textContent = '';

          try {
            const drawer = document.querySelector('cart-drawer');
            const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                items,
                sections: 'cart-drawer,cart-icon-bubble',
                sections_url: window.location.pathname || '/'
              })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description || root.dataset.errorLabel);
            if (!drawer?.renderContents || !result.sections) {
              throw new Error('Your towels were added, but the cart drawer could not open. Please use the cart icon.');
            }

            status.textContent = root.dataset.addedLabel;
            addButton.disabled = false;
            drawer.setActiveElement?.(addButton);
            drawer.renderContents(result);
          } catch (error) {
            status.textContent = error.message || root.dataset.errorLabel;
            addButton.disabled = false;
          }
        });

        refresh();
      });
    })();
  } catch(e) { console.error(e); }
})();

})();
